/* eslint-disable kf/const-naming-convention */
import { EventEmitter } from "./eventemitter.js";

export const globalEvents = new EventEmitter();
